import { actions as all } from './actions/all';
import { actions as appointments } from './actions/appointments';
import { actions as cases } from './actions/cases';
import { actions as citizen } from './actions/citizens';
import { actions as company } from './actions/company';
import { IAction } from './actions/interfaces';
import { actions as offers } from './actions/offers';
import { actions as savedcharts } from './actions/savedcharts';
import { actions as saveddashboards } from './actions/saveddashboards';
import { actions as savedqueries } from './actions/savedqueries';
import { actions as task } from './actions/tasks';
import { actions as citizenjournalnotes } from './actions/citizen-journalnotes';
import { actions as courses } from './actions/courses';
import { actions as activities } from './actions/activities';
import { actions as offerprices } from './actions/offer-prices';
import { actions as bookings } from './actions/bookings';

export function getActions(
  context: string,
  selectedItemsCount: number,
  isFeatureEnabled: (toggle: string) => boolean,
  isTenantAddonEnabled: (toggle: string[]) => boolean,
  hideActionsById: string[],
  forceVisibility?: (id: string) => boolean | undefined
): IAction[] {
  const actions = {
    appointments,
    cases,
    citizen,
    company,
    offers,
    tasks: task, // dashboard resulttype = Tasks, frontpage resulttype= Task
    task,
    savedqueries,
    saveddashboards,
    savedcharts,
    all,
    citizenjournalnotes,
    courses,
    activities,
    offerprices,
    bookings,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any;
  if (!context) {
    return [];
  }
  let result = actions[context.toLocaleLowerCase()];

  if (result) {
    result = result.concat(all);
  } else {
    result = all;
  }

  const visibleActions: IAction[] = result.filter((item: IAction) =>
    item.isVisible ? item.isVisible(selectedItemsCount, isFeatureEnabled, isTenantAddonEnabled, forceVisibility) : true
  );
  const contextLower = context.toLocaleLowerCase();
  return visibleActions.filter(
    x => (!x.contextOnlyAction || x.showOnlyForContext === contextLower) && !hideActionsById.includes(x.id) && (!x.showOnlyForContext || x.showOnlyForContext === contextLower)
  );
}

export function getUniverseActions(
  context: string,
  selectedItemsCount: number,
  isFeatureEnabled: (toggle: string) => boolean,
  isTenantAddonEnabled: (addonNames: string[]) => boolean,
  hideActionsById: string[],
  forceVisibility?: (id: string) => boolean | undefined,
  universe?: string
): IAction[] {
  const actions = {
    appointments,
    cases,
    citizen,
    company,
    offers,
    tasks: task, // dashboard context = Tasks, frontpage resulttype= Task
    task,
    all,
    courses,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any;
  if (!context || !universe || universe.toLocaleLowerCase() === context.toLocaleLowerCase()) {
    return [];
  }
  const result = actions[universe.toLocaleLowerCase()] || [];

  const visibleActions: IAction[] = result.filter((item: IAction) =>
    item.isVisible ? item.isVisible(selectedItemsCount, isFeatureEnabled, isTenantAddonEnabled, forceVisibility) : true
  );

  const contextLower = context.toLocaleLowerCase();
  return visibleActions.filter(
    x => (x.showOnUniverseAction || x.contextOnlyAction) && !hideActionsById.includes(x.id) && (!x.showOnlyForContext || x.showOnlyForContext === contextLower)
  );
}
